import {
  Paper,
  Box,
  Typography,
  Divider,
  Checkbox,
  MenuItem,
  FormControl,
  ListItemText,
  OutlinedInput,
  Select,
} from '@mui/material'
import { DropDown } from 'Common/Supplyvue-ui'
import {
  FILE_NAME,
  FILE_VERSION,
  PLANNING_BOOK_LEDGER,
  SET_FILE_NAME,
  SET_FILE_VERSION,
  SET_KEY_FIGURES,
} from './DownloadData.constants'
import { DataDownloadSettingsProps } from 'Features/DownloadDataModal/DownloadDataModal.types'
import { useEffect, useState } from 'react'

// Replace KEY_FIGURES_ARRAY with data that matches Planning Book data
//
//
//

export const DownloadDataView = ({
  keyMeasures,
  fileNameLabel,
  fileVersionLabel,
  keyFiguresLabel,
  fileName,
  fileFormat,
  fileVersion,
  keyFigures,
  updateState,
  fileNames = FILE_NAME,
  keyFigureLabels,
}: DataDownloadSettingsProps) => {
  // The ledger's key figures are codes; the menu shows their labels.
  const keyFigureLabel = (value: string) => keyFigureLabels?.[value] ?? value

  const [selectedFileFormat, setSelectedFileFormat] =
    useState<string>(fileFormat)

  const ITEM_HEIGHT = 38
  const ITEM_PADDING_TOP = 8
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 15 + ITEM_PADDING_TOP,
      },
    },
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right',
    },
    getContentAnchorEl: null,
    autoFocus: false,
  }

  const FileVersionDropDown = () => {
    const [selectedVersions, setSelectedVersions] = useState<string[]>([
      ...fileVersion,
    ])

    const onClose = () => {
      updateState({
        type: SET_FILE_VERSION,
        payload: selectedVersions,
      })
    }

    const handleClick = (value) => {
      const newVersions = [...selectedVersions]

      const index = newVersions.indexOf(value)
      if (index > -1) {
        newVersions.splice(index, 1)
      } else {
        newVersions.push(value)
      }
      setSelectedVersions(newVersions)
    }

    return (
      <Box>
        <FormControl fullWidth={true} disabled={fileName === 'Capacity Data'}>
          <Select
            labelId="File Versions Dropdown"
            id="File Versions Dropdown"
            multiple
            value={selectedVersions}
            fullWidth={true}
            onClose={onClose}
            input={<OutlinedInput />}
            renderValue={(selected) => selected.join(', ')}
            MenuProps={MenuProps}
          >
            {FILE_VERSION.map((name) => (
              <MenuItem
                key={name}
                value={name}
                onClick={() => handleClick(name)}
              >
                <Checkbox
                  checked={selectedVersions.indexOf(name) > -1}
                  value={name}
                />
                <ListItemText primary={name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    )
  }

  const KeyFiguresDropDown = () => {
    const [itemName, setItemName] = useState<string[]>([...keyFigures])
    const [selectAll, setSelectAll] = useState<boolean>(true)
    useEffect(() => {
      if (keyMeasures.length > 0) {
        setItemName(keyMeasures)
        setSelectAll(true)
      }
    }, [keyMeasures])
    const menu_items = keyMeasures
    const handleSelectAll = (value) => {
      if (selectAll) {
        setItemName([])
      } else {
        setItemName(menu_items)
      }

      setSelectAll(!value)
    }

    const onClose = () => {
      updateState({
        type: SET_KEY_FIGURES,
        payload: itemName,
      })
    }

    const handleClick = (value) => {
      const newItems = [...itemName]

      const index = newItems.indexOf(value)
      if (index > -1) {
        newItems.splice(index, 1)
      } else {
        newItems.push(value)
      }
      setItemName(newItems)
    }

    return (
      <Box>
        <FormControl
          fullWidth={true}
          disabled={
            fileName !== 'DRP Outputs' &&
            fileName !== 'DRP Outputs (Pivot)' &&
            fileName !== PLANNING_BOOK_LEDGER
          }
        >
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            value={itemName}
            fullWidth={true}
            onClose={onClose}
            input={<OutlinedInput />}
            renderValue={(selected) => selected.map(keyFigureLabel).join(', ')}
            MenuProps={MenuProps}
          >
            <MenuItem
              value={selectAll}
              onClick={() => handleSelectAll(selectAll)}
            >
              <Checkbox checked={selectAll} />
              <ListItemText primary="Select/Deselect All" />
            </MenuItem>
            <Divider
              sx={{
                height: '3px',
                background: '#006286',
                width: '100%',
              }}
            />
            {menu_items.map((name) => (
              <MenuItem
                key={name}
                value={name}
                onClick={() => handleClick(name)}
              >
                <Checkbox checked={itemName.indexOf(name) > -1} value={name} />
                <ListItemText primary={keyFigureLabel(name)} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    )
  }

  return (
    <Paper elevation={0}>
      <Box display="flex" minHeight="20vh" flexDirection="column">
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          mt={2}
        >
          <Box display="flex" flexDirection="column">
            <Box width="15rem">
              <Typography variant="h4">Metric</Typography>
            </Box>
          </Box>

          <Box display="flex" flexDirection="column">
            <Box width="15rem">
              <Typography variant="h4">Action</Typography>
            </Box>
          </Box>
        </Box>
        <Box display="flex" flexDirection="row" justifyContent="space-between">
          <Divider
            flexItem
            sx={{
              height: '3px',
              background: '#006286',
              width: '100%',
              marginTop: '1rem',
            }}
          />
        </Box>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
          mt={2}
        >
          <Box display="flex" flexDirection="column">
            <Box width="15rem">
              <Typography variant="h4">{fileNameLabel}</Typography>
            </Box>
          </Box>
          <Box display="flex" flexDirection="column">
            <Box width="15rem">
              <DropDown
                id={fileNameLabel}
                value={fileName}
                sx={{ minWidth: '150px' }}
                fullWidth={true}
                onChange={(e) =>
                  updateState({
                    type: SET_FILE_NAME,
                    payload: e.target.value as string,
                  })
                }
                menuItems={fileNames}
                label={fileNameLabel}
              />
            </Box>
          </Box>
        </Box>

        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
          mt={2}
        >
          <Box display="flex" flexDirection="column">
            <Box width="15rem">
              <Typography variant="h4">{fileVersionLabel}</Typography>
            </Box>
          </Box>
          <Box display="flex" flexDirection="column" width="15rem">
            <FileVersionDropDown />
          </Box>
        </Box>
        <Box
          mt={2}
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box display="flex" flexDirection="column">
            <Box width="15rem">
              <Typography variant="h4">{keyFiguresLabel}</Typography>
            </Box>
          </Box>
          <Box display="flex" flexDirection="column" width="15rem">
            <KeyFiguresDropDown />
          </Box>
        </Box>
      </Box>
    </Paper>
  )
}
